<template>
  <vue-apex-charts
    :type="template"
    :height="height"
    :options="chartOptions" :series="verticalAxisSeries"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "polarArea-pie-donut-chart",
  components: {
    VueApexCharts,
  },
  props:{
    template:String,
    horizontalAxis:Array,
    verticalAxisSeries:Array,
    height:String,
  },
  data() {
    return {
      chartOptions: {
        labels: this.horizontalAxis,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
    }
  }
}
</script>

<style scoped>

</style>
